import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const RestoreUserByIdRequestDtoSchema = z.object({
  id: z.number(),
});

const RestoreUserByIdResponseDtoSchema = UserDtoSchema;

export type RestoreUserByIdRequestDto = z.infer<
  typeof RestoreUserByIdRequestDtoSchema
>;
export type RestoreUserByIdResponseDto = z.infer<
  typeof RestoreUserByIdResponseDtoSchema
>;

export const restoreUserById = (
  dto: RestoreUserByIdRequestDto,
  config?: AxiosRequestConfig
) => {
  const data = RestoreUserByIdRequestDtoSchema.parse(dto);
  return api
    .post(`/users/restore/${data.id}`, {}, config)
    .then(responseContract(RestoreUserByIdResponseDtoSchema));
};
